<template v-if="companyData.content">
  <div class="mb-2">
    <!-- Header: Personal Info -->
    <div class="d-flex">
      <feather-icon icon="UserIcon" size="19" />
      <h4 class="mb-0 ml-50">Detail Information</h4>
    </div>

    <!-- User Info: Input Fields -->
    <b-form class="mt-1">
      <b-row
          v-for="(content, index) in companyData.content"
          :key="'content' + index"
        >
        <!-- Field: About -->
        <b-col sm="12" md="2">
          <div class="custom-label">About:</div>
        </b-col>
        <b-col cols="12" md="10">
          <div
            class="form-control form-group custom-content-preview"
            v-html="content.about ? content.about : '-'"
          ></div>
        </b-col>
        

        <!-- Field: sort -->
        <b-col cols="12" md="4">
          <b-form-group label="Sort" label-for="sort">
            <b-form-input
              id="sort"
              :value="companyData.hasOwnProperty('sort') ? companyData.sort : '-'"
              readonly
            />
          </b-form-group>
        </b-col>

        
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { BRow, BCol, BFormGroup, BFormInput, BForm } from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
  },
  props: {
    companyData: {
      type: Object,
      required: true,
    },
  },
  setup(props) {

    return {
      avatarText,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
